import { cn } from '@/lib/utils';
import { Skeleton } from '../Skeleton';
import { ShapeGroup } from './ShapeGroup';

const NAME_WIDTHS = ['55%', '40%', '65%', '48%'];
const SUB_WIDTHS = ['35%', '28%', '42%'];

interface ListRowsSkeletonProps {
  rows?: number;
  /** A round avatar before the text (people, cards). Default true. */
  avatar?: boolean;
  /** Each row sits in its own bordered card, like a club or membership list. Default false. */
  framed?: boolean;
  label?: string;
  className?: string;
}

/** Rows of a name line over a smaller line, optionally with an avatar. */
export function ListRowsSkeleton({
  rows = 3,
  avatar = true,
  framed = false,
  label,
  className,
}: ListRowsSkeletonProps) {
  return (
    <ShapeGroup label={label} className={cn(framed ? 'space-y-3' : 'space-y-4', className)}>
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          data-skeleton-row=""
          className={cn(
            'flex items-center gap-3',
            framed && 'border-border bg-card rounded-lg border p-4',
          )}
        >
          {avatar && <Skeleton className="h-10 w-10 shrink-0 rounded-full" />}
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton.Line width={NAME_WIDTHS[i % NAME_WIDTHS.length]} className="h-4" />
            <Skeleton.Line width={SUB_WIDTHS[i % SUB_WIDTHS.length]} />
          </div>
        </div>
      ))}
    </ShapeGroup>
  );
}
